import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { filter, map } from 'rxjs';

import { UserService } from '@shared/services/user';

export const profileGuard: CanActivateFn = (_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const userService = inject(UserService);

  return userService.profile$.pipe(
    map((profile) => !!profile),
    filter((isProfileLoaded: boolean) => isProfileLoaded)
  );
};
